import { PosServiceProvider } from './../../providers/pos-service/pos-service';
import { AuthProvider } from './../../providers/auth/auth';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';

@IonicPage()
@Component({
  selector: 'page-pos-sale',
  templateUrl: 'pos-sale.html',
})
export class PosSalePage {

  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';

  activeTab: string = 'item';

  // Shared filters
  outlets: any[] = [];
  selectedOutlet: string = '';
  dateFrom: string = '';
  dateTo: string = '';

  // Sales Item
  saleItems: any[] = [];
  totalItemRec = 0;
  totalItemQty = 0;
  totalItemAmt = 0;
  itemLoaded: boolean = false;

  // Sales Statistic
  statData: any = null;
  statLoaded: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private posservice: PosServiceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider) {
      let info = this.auth.getUserInfo();
      this.name = info.name;
      this.username = info.username;
      this.serverlocation = info.serverlocation;
      this.userid = info.userid;
      this.token = info.token;

      let now = new Date();
      this.dateFrom = now.toISOString();
      this.dateTo = now.toISOString();

      this.loadOutlets();
  }

  loadOutlets() {
    this.posservice.loadOutlet(this.userid, this.token, this.serverlocation, this.global.ICNO)
      .then((data: any) => {
        if (data && Array.isArray(data)) {
          this.outlets = data;
        }
      })
      .catch(() => {});
  }

  switchTab(tab: string) {
    this.activeTab = tab;
    if (tab === 'item' && !this.itemLoaded) {
      this.loadSaleItems();
    } else if (tab === 'statistic' && !this.statLoaded) {
      this.loadStatistic();
    }
  }

  private getFilterDates(): { strFrom: string, strTo: string } {
    let dFrom = new Date(this.dateFrom);
    let dTo = new Date(this.dateTo);
    let strFrom = dFrom.getFullYear() + '-' + ('0' + (dFrom.getMonth() + 1)).slice(-2) + '-' + ('0' + dFrom.getDate()).slice(-2);
    let strTo = dTo.getFullYear() + '-' + ('0' + (dTo.getMonth() + 1)).slice(-2) + '-' + ('0' + dTo.getDate()).slice(-2);
    return { strFrom, strTo };
  }

  // ---- Sales Item ----
  loadSaleItems() {
    this.showLoading();
    this.itemLoaded = false;

    let { strFrom, strTo } = this.getFilterDates();

    this.posservice.loadPOSSaleItem(this.userid, this.token, this.serverlocation, this.global.ICNO, strFrom, strTo, this.selectedOutlet)
      .then((data: any) => {
        if (data && Array.isArray(data)) {
          this.saleItems = data;
        } else {
          this.saleItems = [];
        }
        this.computeItemTotals();
        this.itemLoaded = true;
        if (this.loading) this.loading.dismiss();
      })
      .catch(() => {
        this.saleItems = [];
        this.computeItemTotals();
        this.itemLoaded = true;
        if (this.loading) this.loading.dismiss();
      });
  }

  computeItemTotals() {
    let total = 0;
    let qty = 0;
    let count = 0;
    for (let rec of this.saleItems) {
      total += Number(String(rec.Total).replace(/,/g, ''));
      qty += Number(rec.Qty);
      count++;
    }
    this.totalItemRec = count;
    this.totalItemQty = qty;
    this.totalItemAmt = total;
  }

  // ---- Sales Statistic ----
  loadStatistic() {
    this.showLoading();
    this.statLoaded = false;

    let { strFrom, strTo } = this.getFilterDates();

    this.posservice.loadPOSSaleStatistic(this.userid, this.token, this.serverlocation, this.global.ICNO, strFrom, strTo, this.selectedOutlet)
      .then((data: any) => {
        if (data && data.status === 200 && data.data) {
          this.statData = data.data;
        } else {
          this.statData = null;
        }
        this.statLoaded = true;
        if (this.loading) this.loading.dismiss();
      })
      .catch(() => {
        this.statData = null;
        this.statLoaded = true;
        if (this.loading) this.loading.dismiss();
      });
  }

  // ---- Shared ----
  onOutletChange() {
    if (this.activeTab === 'item') {
      this.loadSaleItems();
    } else {
      this.loadStatistic();
    }
  }

  onDateFromChange() {
    if (this.activeTab === 'item') {
      this.loadSaleItems();
    } else {
      this.loadStatistic();
    }
  }

  onDateToChange() {
    if (this.activeTab === 'item') {
      this.loadSaleItems();
    } else {
      this.loadStatistic();
    }
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  doRefresh(refresher) {
    if (this.activeTab === 'item') {
      this.loadSaleItems();
    } else {
      this.loadStatistic();
    }
    setTimeout(() => {
      refresher.complete();
    }, 2000);
  }

  formatNumber(value) {
    if (value == null) return '0';
    let num = Number(value);
    if (isNaN(num)) return '0';
    let parts = num.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');
  }

  formatShortDate(dateStr) {
    if (!dateStr) return '';
    let d = new Date(dateStr);
    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PosSalePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/pos-sale/pos-sale.ts